<script>
  // import BoardDocuments from '@/components/board-documents.vue'
  // import BoardMembersCard from '@/components/board-members-card.vue'
  import BoardScheduleCard from '@/components/board-schedule-card.vue'
  import ContactCard from '@/components/contact-card.vue'
  import DirectionsCard from '@/components/directions-card.vue'
  // import DirectorCard from '@/components/card-director-profile.vue'
  // import HeadshotCircle from '@/components/headshot-circle.vue'
  import HoursCard from '@/components/hours-card.vue'
  import MaterialPeriodsFinesCard from '@/components/material-periods-fines-card.vue'
  import PageHeader from '@/components/page-header.vue'
  import PoliciesCard from '@/components/policies-card.vue'

  export default {
    name: 'about-home',
    components: {
      // BoardDocuments,
      // BoardMembersCard,
      BoardScheduleCard,
      ContactCard,
      // DirectorCard,
      // HeadshotCircle,
      HoursCard,
      DirectionsCard,
      MaterialPeriodsFinesCard,
      PageHeader,
      PoliciesCard
    },
    data: () => ({
      chipItems: [
        {
          key: 1,
          icon: 'mdi-store-clock',
          label: 'Hours',
          slug: 'hours',
          value: 'hours'
        },
        {
          key: 2,
          icon: 'mdi-map-marker',
          label: 'Location',
          slug: 'location',
          value: 'location'
        },
        {
          key: 3,
          icon: 'mdi-phone',
          label: 'Contact',
          slug: 'contact',
          value: 'contact'
        },
        {
          key: 4,
          icon: 'mdi-book-information-variant',
          label: 'Materials',
          slug: 'material',
          value: 'material'
        },

        // {
        //   key: 5,
        //   icon: 'mdi-account-tie',
        //   label: 'Director',
        //   slug: 'director',
        //   value: 'director'
        // },
        {
          key: 6,
          icon: 'mdi-file-document',
          label: 'Docs/Policies',
          slug: 'policies',
          value: 'policies'
        },
        {
          key: 5,
          icon: 'mdi-account-tie',
          label: 'Board',
          slug: 'board',
          value: 'board'
        }
      ],
      chipItemSelected: null
    }),
    methods: {
      onChipChange(selected) {
        const chip = this.chipItems.find(c => c.value === selected)
        if (!chip) {
          this.chipItemSelected = null
          return
        }
        if (this.$route?.params?.anchor !== chip.slug) {
          this.$router.push({
            name: 'about',
            params: {
              anchor: chip.slug || null
            }
          })
        }
        const el = document.querySelector(`#${chip.slug}`)
        this.$nextTick(() => el.scrollIntoView({ behavior: 'smooth', block: 'end' }))
      }
    },
    mounted() {
      console.log('created')
      const slug = this.$route?.params?.anchor
      if (!slug) {
        this.chipItemSelected = null
        return
      }
      const chip = this.chipItems.find(c => c.slug === slug)
      if (chip) {
        this.chipItemSelected = chip.value
        // this.onChipChange(chip.value)
        setTimeout(() => {
          this.onChipChange(chip.value)
        }, 500)
      }
    }
    // watch: {
    //   $route(a) {
    //     const anchor = a?.params?.anchor || ''
    //     const chip = this.chipItems.find(c => c.slug === anchor)
    //     console.log(anchor)
    //     console.log(chip)
    //     if (!chip) return
    //     const el = document.querySelector(`#${chip.slug}`)
    //     console.log(el)
    //     el.scrollIntoView({ behavior: 'smooth', block: 'end' })
    //     this.$nextTick(() => el.scrollIntoView({ behavior: 'smooth', block: 'end' }))
    //     // setTimeout(() => {
    //     //   el.scrollIntoView({ behavior: 'smooth', block: 'end' })
    //     // }, 250)
    //   },
    // },
  }
</script>

<template>
  <v-sheet height="100%" class="main-container">
    <v-img
      cover
      position="center center"
      src="https://media.eipl.org/site/images/building/second-floor.jpg"
      class="hero-image"
      :style="{
        height: `calc(100vh - ${$vuetify.application.top}px + 100px)`,
        top: '50px'
      }"
    ></v-img>
    <page-header
      v-model="chipItemSelected"
      :autoHide="false"
      backgroundColor="#c5bdbb"
      :chipItems="chipItems"
      titleText="ABOUT US"
      :titleColor="$vuetify.theme.themes.light.primary"
      @input="onChipChange"
    ></page-header>
    <v-container fluid class="d-flex flex-column transparent align-center px-4">
      <v-row align="start" align-contet="center" justify="center">
        <v-col cols="12" class="d-flex justify-center">
          <v-card color="#FFFFFFDB" max-width="800" outlined width="100%" class="mission-statement">
            <v-card-title class="primary--text text-h5 font-weight-bold">Our Mission Statement</v-card-title>
            <v-card-text class="primary--text font-weight-bold">
              <p>
                The Staff and Trustees of the East Islip Public Library are dedicated to serving the educational cultural and intellectual needs of the communities of East Islip,
                Islip Terrace and Great River.
              </p>
              <p><em>-Adapted: December 15, 1992</em></p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" class="d-flex justify-center mt-10">
          <hours-card id="hours"></hours-card>
        </v-col>
        <v-col cols="12" class="d-flex justify-center mt-10">
          <directions-card id="location"></directions-card>
        </v-col>
        <v-col cols="12" class="d-flex justify-center mt-10">
          <contact-card id="contact"></contact-card>
        </v-col>
        <v-col cols="12" class="d-flex justify-center mt-10">
          <material-periods-fines-card id="material"></material-periods-fines-card>
        </v-col>
        <!-- MOVE THESE TO COMPONENT -->
        <v-col cols="12" class="d-flex justify-center mt-10">
          <policies-card id="policies" />
        </v-col>
        <v-col cols="12" class="d-flex justify-center mt-10">
          <board-schedule-card />
        </v-col>
        <!-- <v-col cols="12" class="d-flex justify-center mt-10">
          <board-members-card class="mt-16" />
        </v-col> -->
        <!-- <v-col cols="12" class="d-flex justify-center mt-10">
          <board-documents class="mt-16" />
        </v-col> -->
      </v-row>
    </v-container>
  </v-sheet>
</template>
<style scoped>
  .main-container {
    /* --background: #ff9800;
    background-color: var(--background); 
    */
    background-color: #c5bdbb;
  }
  .hero-image {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    filter: grayscale(50%);
    /* opacity: 0.8; */
    z-index: 0;
  }
  .hero-image :before {
    content: '';
    background-image: linear-gradient(to top, #c5bdbb, rgba(239, 239, 239, 0));
    position: absolute;
    height: 100px;
    right: 0;
    bottom: 0;
    left: 0;
  }
  .content-container {
    position: relative;
    z-index: 1;
  }

  .mission-statement {
    margin-block: 12vh;
    border: 1px solid var(--v-primary-base) !important;
  }

  >>> .v-card__title {
    white-space: wrap;
    word-break: break-word;
  }
</style>
